import { useRouter } from 'next/router';

import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';

import React, { useEffect, useState } from 'react';

// TODO: 사용하지 않는 홍보페이지로 추후 삭제 할것
function Home({ defaultMetaTagData }) {
  const [eventTab, setEventTab] = useState(1);
  const metaTagData = {
    shareTitle: 'SBS 이벤트 : 홈페이지 새단장 이벤트',
    shareDescription: '달라진 SBS에서 풍성한 콘텐츠를 즐겨보세요',
    shareImageUrl:
      'https://program-image.cloud.sbs.co.kr/og/2025/sbs_event.png',
    currentUrl: 'https://www.sbs.co.kr/promotion/open-event-2021',
    keywords: '룰렛 이벤트, 개편 이벤트, SBS VOD 무료, SBS VOD 할인',
  };

  const eventProgramList = [
    {
      programTitle: '모범택시',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster01.png',
    },
    {
      programTitle: '펜트하우스',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster02.png',
    },
    {
      programTitle: '앨리스',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster03.png',
    },
    {
      programTitle: '하이에나',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster04.png',
    },
    {
      programTitle: '낭만닥터 김사부 2',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster05.png',
    },
    {
      programTitle: '진짜 농구,핸섬 타이거즈',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster06.png',
    },
    {
      programTitle: '트롯신이 떴다',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster07.png',
    },
    {
      programTitle: '세기의 대결 AI VS 인간',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster08.png',
    },
    {
      programTitle: '꼬리에 꼬리를 무는 이야기',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster09.png',
    },
    {
      programTitle: '당신이 혹하는 사이',
      programPosterImg:
        '/images/promotion/2021-open-event/pc/event_poster10.png',
    },
  ];

  let nextIndex = 0;
  const moveTopSlide = (isNext) => {
    const maxSlideIndex = 2;

    if (isNext) {
      if (nextIndex + 1 <= maxSlideIndex) {
        nextIndex++;
      } else {
        return;
      }
    } else {
      if (nextIndex - 1 < 0) {
        return;
      } else {
        nextIndex--;
      }
    }

    const targetElements = window.document.querySelectorAll(
      'div[class^=event_top_slide_cont]'
    );

    if (targetElements?.forEach) {
      targetElements.forEach((x) => x.classList.remove('current'));
      targetElements[nextIndex].classList.add('current');
    }
  };

  const moveEventTab = (tabIndex) => {
    setEventTab(tabIndex);

    const position = getElementPosition(`event_middle_content_0${tabIndex}`);
    scrollTo(position.top, 300);
  };

  const getElementPosition = (id) => {
    let ele = document.getElementById(id);
    let top = 0;
    let left = 0;

    while (ele.tagName !== 'BODY') {
      top += ele.offsetTop;
      left += ele.offsetLeft;
      ele = ele.offsetParent;
    }

    return { top: top, left: left };
  };

  function scrollTo(to, duration) {
    const element = document.documentElement;
    const start = element.scrollTop;
    const change = to - start;
    let currentTime = 0;
    const increment = 1;

    // t = current time
    // b = start value
    // c = change in value
    // d = duration
    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    const animateScroll = function () {
      currentTime += increment;
      const val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

  const CpntMainIntroduce = () => (
    <div className="event_top_slide_cont current">
      <div className="event_top_slide_players">
        <div className="top_silde_pc_w">
          <div className="top_silde_video_pc">
            <img
              src="/images/promotion/2021-open-event/pc/pc_top_1main_img.jpg"
              alt=""
            />
          </div>
          <span className="top_silde_bg_pc" />
        </div>
        <div className="top_silde_mobile_w">
          <div className="top_silde_video_mobile">
            <img
              src="/images/promotion/2021-open-event/pc/top_1main_img.jpg"
              alt=""
            />
          </div>
          <span className="top_silde_bg_mobile" />
        </div>
      </div>
      <div className="event_top_slide_info">
        <strong className="top_slide_info_title">Main</strong>
        <em className="top_slide_info_text">
          심플한 블랙화면과
          <br />
          풍성한 프로그램이
          <br />
          한눈에
        </em>
      </div>
    </div>
  );
  const CpntTvSectionIntroduce = () => (
    <div className="event_top_slide_cont">
      <div className="event_top_slide_players">
        <div className="top_silde_pc_w">
          <div className="top_silde_video_pc">
            <img
              src="/images/promotion/2021-open-event/pc/pc_top_2tvsec_img.jpg"
              alt=""
            />
          </div>
          <span className="top_silde_bg_pc" />
        </div>
        <div className="top_silde_mobile_w">
          <div className="top_silde_video_mobile">
            <img
              src="/images/promotion/2021-open-event/pc/top_2tvsec_img.jpg"
              alt=""
            />
          </div>
          <span className="top_silde_bg_mobile" />
        </div>
      </div>
      <div className="event_top_slide_info">
        <strong className="top_slide_info_title">TV Section</strong>
        <em className="top_slide_info_text">
          보고 싶은 프로그램은
          <br />
          찾기 쉽게
        </em>
      </div>
    </div>
  );
  const CpntLiveIntroduce = () => (
    <div className="event_top_slide_cont">
      <div className="event_top_slide_players">
        <div className="top_silde_pc_w">
          <div className="top_silde_video_pc">
            <img
              src="/images/promotion/2021-open-event/pc/pc_top_3live_img.jpg"
              alt=""
            />
          </div>
          <span className="top_silde_bg_pc" />
        </div>
        <div className="top_silde_mobile_w">
          <div className="top_silde_video_mobile">
            <img
              src="/images/promotion/2021-open-event/pc/top_3live_img.jpg"
              alt=""
            />
          </div>
          <span className="top_silde_bg_mobile" />
        </div>
      </div>
      <div className="event_top_slide_info">
        <strong className="top_slide_info_title">LIVE</strong>
        <em className="top_slide_info_text">
          생방송 라이브는
          <br />좀 더 크게,
          <br />좀 더 편하게
        </em>
      </div>
    </div>
  );
  const CpntEventTopContent = () => (
    <div className="event_top_contents">
      <strong className="event_top_label">이렇게 변했어요</strong>
      <div className="event_top_slide_w">
        {/* 메인 */}
        <CpntMainIntroduce />
        {/* TV Section */}
        <CpntTvSectionIntroduce />
        {/* LIVE */}
        <CpntLiveIntroduce />
      </div>
      <div className="event_top_slide_btns">
        <button
          className="top_slide_btn_prev"
          type="button"
          onClick={() => moveTopSlide(false)}
        >
          <span className="slid_btn_arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="14"
              viewBox="0 0 9 14"
            >
              <path d="M1269,783l9-7v14Z" transform="translate(-1269 -776)" />
            </svg>
          </span>
          <i className="ir">이전</i>
        </button>
        <button
          className="top_slide_btn_next"
          type="button"
          onClick={() => moveTopSlide(true)}
        >
          <span className="slid_btn_arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="14"
              viewBox="0 0 9 14"
            >
              <path d="M1339,783l-9,7V776Z" transform="translate(-1330 -776)" />
            </svg>
          </span>
          <i className="ir">다음</i>
        </button>
      </div>
    </div>
  );

  return (
    <>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents">
        {/* 페이지 명 클래스 */}
        <div className="open_event_wrap">
          <div className="event_top_area">
            <h2 className="event_top_title">
              <span className="event_top_tit">홈페이지 새단장 이벤트</span>
            </h2>
            <em className="event_top_text">
              달라진 SBS에서 풍성한 콘텐츠를 즐겨보세요!
            </em>
            <p className="event_top_date">2021.07.12 ~ 2021.08.11</p>
            <CpntEventTopContent />
          </div>
          <div className="event_tab_area">
            <ul className="event_tablist_w">
              <li
                className={`event_tablist_inner${
                  eventTab === 1 ? ' current' : ''
                }`}
              >
                <button
                  type="button"
                  className="event_tab_btn_01"
                  onClick={() => moveEventTab(1)}
                >
                  <strong className="event_tab_text">
                    출첵 포인트 받고
                    <br />꽝 없는 룰렛 도전
                  </strong>
                  <span className="event_tab_arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26.002"
                      height="14.001"
                      viewBox="0 0 26.002 14.001"
                    >
                      <path
                        d="M13.2,14.391a.995.995,0,0,1-.621-.4L.7,2.126A1,1,0,0,1,.7.714L.706.706a1,1,0,0,1,1.415,0l11.3,11.281L24.711.711a.993.993,0,1,1,1.406,1.4L14.274,13.941a1,1,0,0,1-.14.175l-.006.006a1,1,0,0,1-.925.269Z"
                        transform="translate(-0.406 -0.414)"
                      />
                    </svg>
                  </span>
                </button>
              </li>
              <li
                className={`event_tablist_inner${
                  eventTab === 2 ? ' current' : ''
                }`}
              >
                <button
                  type="button"
                  className="event_tab_btn_02"
                  onClick={() => moveEventTab(2)}
                >
                  <strong className="event_tab_text">
                    명작 드라마
                    <br />
                    초고화질이 무료
                  </strong>
                  <span className="event_tab_arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="14"
                      viewBox="0 0 26.002 14.001"
                    >
                      <path
                        d="M13.2,14.391a.995.995,0,0,1-.621-.4L.7,2.126A1,1,0,0,1,.7.714L.706.706a1,1,0,0,1,1.415,0l11.3,11.281L24.711.711a.993.993,0,1,1,1.406,1.4L14.274,13.941a1,1,0,0,1-.14.175l-.006.006a1,1,0,0,1-.925.269Z"
                        transform="translate(-0.406 -0.414)"
                      />
                    </svg>
                  </span>
                </button>
              </li>
              <li
                className={`event_tablist_inner${
                  eventTab === 3 ? ' current' : ''
                }`}
              >
                <button
                  type="button"
                  className="event_tab_btn_03"
                  onClick={() => moveEventTab(3)}
                >
                  <strong className="event_tab_text">
                    최근 종영 프로그램
                    <br />
                    패키지 단돈 1,100원
                  </strong>
                  <span className="event_tab_arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="14"
                      viewBox="0 0 26.002 14.001"
                    >
                      <path
                        d="M13.2,14.391a.995.995,0,0,1-.621-.4L.7,2.126A1,1,0,0,1,.7.714L.706.706a1,1,0,0,1,1.415,0l11.3,11.281L24.711.711a.993.993,0,1,1,1.406,1.4L14.274,13.941a1,1,0,0,1-.14.175l-.006.006a1,1,0,0,1-.925.269Z"
                        transform="translate(-0.406 -0.414)"
                      />
                    </svg>
                  </span>
                </button>
              </li>
            </ul>
          </div>
          <div className="event_middle_area">
            {/* 01. 출첵으로 포인트 받고 꽝 없는 룰렛 도전 */}
            <div
              className="event_middle_content_01"
              id="event_middle_content_01"
            >
              <div className="event_middle_content_inner">
                <div className="middle_cont_01">
                  <em className="middle_cont_number">01.</em>
                  <strong className="middle_cont_title">
                    출첵으로 포인트 받고
                    <br />
                    <span className="middle_cont_point">꽝 없는</span> 룰렛 도전
                  </strong>
                  <p className="middle_cont_text">
                    우수참여자 중 추첨을 통해
                    <br />
                    특별한 선물도 드려요.
                  </p>
                  <div className="middle_cont_btns">
                    <a
                      className="middle_cont_btn"
                      href="//w3.sbs.co.kr/event/attendanceCheckEventPage.do"
                    >
                      출석 체크하기
                    </a>
                    <a className="middle_cont_btn" href="/roulette/index.html">
                      룰렛 참여하기
                    </a>
                  </div>
                </div>
                <div className="middle_cont_images01">
                  <div className="middle_cont_bg">
                    <img
                      src="/images/promotion/2021-open-event/pc/roulette_bg.png"
                      alt="룰렛이벤트 이미지"
                    />
                  </div>
                  <div className="middle_cont_img">
                    <img
                      src="/images/promotion/2021-open-event/pc/roulette_element.gif"
                      alt="룰렛이벤트 경품 이미지"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* 02. 명작 드라마 초고화질이 무료 */}
            <div
              className="event_middle_content_02"
              id="event_middle_content_02"
            >
              <div className="event_middle_content_inner">
                <div className="middle_cont_02">
                  <em className="middle_cont_number">02.</em>
                  <strong className="middle_cont_title">
                    명작 드라마
                    <br />
                    초고화질이 <span className="middle_cont_point">무료</span>
                  </strong>
                  <p className="middle_cont_text">
                    황후의 품격, 괜찮아 사랑이야, 파리의 연인 등<br />
                    초고화질로 무료 시청할 수 있어요.
                  </p>
                  <div className="middle_cont_btns">
                    <a
                      href="/tv?sort=theme&div=open_event"
                      className="middle_cont_btn"
                    >
                      무료 보러 가기{' '}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* 03. 최근 종영 프로그램 패키지 단돈 1,100원 */}
            <div
              className="event_middle_content_03"
              id="event_middle_content_03"
            >
              <div className="event_middle_content_inner">
                <div className="middle_cont_03">
                  <em className="middle_cont_number">03.</em>
                  <strong className="middle_cont_title">
                    최근 종영 프로그램 패키지 단돈{' '}
                    <span className="middle_cont_point">1,100원</span>
                  </strong>
                  <p className="middle_cont_text">
                    최근 종영 된 프로그램 전회차를 파격 할인가로 보실 수 있어요.
                  </p>
                  <div className="middle_cont_btns">
                    <a
                      href="/tv?sort=theme&div=open_event"
                      className="middle_cont_btn"
                    >
                      구매하기{' '}
                    </a>
                  </div>
                </div>
              </div>

              <ul className="event_proglist_w">
                {eventProgramList.map((item, index) => {
                  return (
                    <li className="event_proglist_inner" key={index}>
                      <Image
                        className="event_proglist_img"
                        layout="fixed"
                        width="220"
                        height="311"
                        src={item.programPosterImg}
                        alt={`${item.programTitle} 프로그램 이미지`}
                      />
                      <strong className="event_proglist_title">
                        {item.programTitle}
                      </strong>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="event_bottom_bg" />
        </div>
      </div>
    </>
  );
}

export default Home;
